import { UnitSizeRead } from "@types";

export function getUnitSizesDetails(data?: UnitSizeRead | null) {
  if (!data) return { sections: [] };

  const sections: any[] = [];

  if (data.imageUrl) {
    sections.push({
      type: "image",
      title: "Image",
      icon: "pi-image",
      src: data.imageUrl,
      alt: `Image of ${data.description}`,
    });
  }

  sections.push({
    title: "Dimensions",
    icon: "pi-arrows-alt",
    fields: [
      { label: "Description", value: data.description },
      { label: "Width", value: data.width },
      { label: "Length", value: data.length },
    ],
  });

  return { sections };
}
